import './preloader.css';

export const Preloader = () => {
  return (
    <div className='preloader'>
      <div></div>
    </div>
  );
};
